export default __webpack_public_path__ + "static/media/Ubuntu-R.768d480f.ttf";